import { TEXT_STYLES } from "@/components/form-builder/form-components/utils/configs";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Info, Link } from "lucide-react";
import React from "react";
import sanitizeHtml from "sanitize-html";
type LinkFieldProps = {
  title: string;
  url: string;
  buttonTitle?: string;
  textStyle?: (typeof TEXT_STYLES)[number];
};
const LinkField = ({
  title,
  url,
  textStyle,
  buttonTitle
}: LinkFieldProps) => {
  const getTextClassName = () => {
    switch (textStyle) {
      case "Bold":
        return "font-bold";
      case "Info":
        return "text-[#3159ab] dark:text-[#5987e2]";
      case "Small Bold":
        return "font-semibold";
      default:
        return "";
    }
  };
  const renderIcon = () => {
    if (textStyle === "Info") {
      return <Info className={getTextClassName()} />;
    }
    return null;
  };
  return <div className="flex items-center justify-between gap-4" data-sentry-component="LinkField" data-sentry-source-file="LinkField.tsx">
      <div className="flex gap-2">
        {renderIcon()}
        <p className={cn(getTextClassName())} dangerouslySetInnerHTML={{
        __html: sanitizeHtml(title)
      }}></p>
      </div>
      <a href={url} className="flex gap-5" target="_blank">
        <Button type="button" className="flex gap-2" data-sentry-element="Button" data-sentry-source-file="LinkField.tsx">
          {buttonTitle || "Vezi link"} <Link size={15} data-sentry-element="Link" data-sentry-source-file="LinkField.tsx" />
        </Button>
      </a>
    </div>;
};
export default LinkField;